var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"global-spinner-container",attrs:{"align-v":"center","align-h":"center"}},[_c('half-circle-spinner',{attrs:{"animation-duration":_vm.speedAnimation,"size":_vm.sizeAnimation,"color":_vm.colorAnimation}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cd69694","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/Spinner.vue
// module id = null
// module chunks = 